<template>
  <div>
    <el-collapse v-model="collapseParent" class="collapsed without-bottom-b" accordion>
      <el-collapse-item
        v-for="(item, index) in normalizeCollapseOptions"
        :key="index"
        :title="item.title"
        :name="item.name"
      >
        <div v-if="!item.hasChildCollapse">
          <template v-for="(element, i) in item.items">
            <template v-if="Boolean(element.eltype)">
              <component
                :is="element.eltype"
                :key="i"
                v-bind="element"
                :element="element"
                :type="element.type"
                :default="element.default"
                :options="element.options"
                @changeOptionCSS="changeOptionCSS"
              />
            </template>
            <template v-else>
              <component :is="element.type" :key="i" v-bind="element" :element="element" />
            </template>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-model="collapseDimensions" class="collapsed without-bottom-b" accordion>
      <el-collapse-item
        v-for="(item, index) in normalizeCollapseOptionsCSS"
        :key="index"
        :title="item.title"
        :name="item.name"
      >
        <div v-if="!item.hasChildCollapse">
          <template v-for="(element, i) in item.items">
            <template v-if="Boolean(element.eltype)">
              <component
                :is="element.eltype"
                :key="i"
                v-bind="element"
                :element="element"
                :type="element.type"
                :default="element.default"
                :options="element.options"
                @changeOptionCSS="changeOptionCSS"
              />
            </template>
            <template v-else>
              <component :is="element.type" :key="i" v-bind="element" :element="element" />
            </template>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapState } from "vuex";


import CheckboxLoadSirv from "@/widgets/options/CheckboxLoadSirv";
import RadioPrefetch from "@/widgets/options/RadioPrefetch.vue";
import NumberCSS from "@/widgets/options_css/NumberCSS";
import mixinQueryChangeParamsCSS from "@/store/observable/query-change-params-css";
import { enabledField } from "@/mixins/enabledField.mixin";
import RadioInput from "@/widgets/options/RadioInput";
import RadioInline from "@/widgets/options/RadioInline";

export default {
  name: "ScriptsElements",
  components: {
    CheckboxLoadSirv,
    RadioPrefetch,
    NumberCSS,
    RadioInline,
    RadioInput,
  },
  mixins: [enabledField, mixinQueryChangeParamsCSS],
  data() {
    return {
      collapseParent: [],
      collapseDimensions: [],
      queryChangeParamsCSS: [],
      queryChangeParams: null,
    };
  },
  computed: {
    ...mapState([
      "collapseOptions",
      "collapseOptionsCSS",
      "settings",
      "clearOptions",
      "clearOptionsCSS",
    ]),
    normalizeCollapseOptions() {
      return this.collapseOptions.filter((it) => it.title === "JS");
    },
    normalizeCollapseOptionsCSS() {
      return this.collapseOptionsCSS.filter((it) => it.title === "Dimensions");
    },
    optionsCopy() {
      return this.settings.options;
    },
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.collapseDimensions = [];
        this.collapseParent = [];
        this.queryChangeParams = null;
      }
    },
    clearOptionsCSS(value) {
      if (value) {
        this.queryChangeParamsCSS = [];
      }
    },
    collapseOptionsCSS(val) {
      let tempStorage = [];
      this.queryChangeParams = [];
      val.forEach((item) => {
        if (item.hasChildCollapse === false) {
          item.items.forEach((el) => {
            if (el.eventClick === true) {
              tempStorage.push(el);
            }
          });
        } else {
          item.collapseChildOptions.forEach((el) => {
            if (el.hasChildCollapse === false) {
              el.items.forEach((innerEl) => {
                if (innerEl.eventClick === true) {
                  tempStorage.push(innerEl);
                }
              });
            }
          });
        }
      });

      let inlineModeSMVCollapse = tempStorage.filter(
        (item) => item.parameter.indexOf("inlineModeSMV") !== -1
      );
      if (inlineModeSMVCollapse.length > 0) {
        this.collapseDimensions = "12";
      }
    },
  },
  methods: {
    checkZoomOption(params) {
      this.$store.dispatch("enableZoom", params);
    },
    changeOptionCSS(params) {
      if (!params.value && !params.parameter) {
        this.queryChangeParamsCSS = [];
        this.$store.dispatch("changeOptionCSS", {
          optionCSS: this.queryChangeParamsCSS,
        });
        return;
      }

      if (params.value !== "") {
        let check = this.queryChangeParamsCSS.find((item) => {
          return item.parameter === params.parameter && item.type === params.type;
        });

        if (check === undefined) {
          this.queryChangeParamsCSS.push(params);
        } else {
          this.queryChangeParamsCSS.map((item) => {
            if (
              item &&
              item.hiddenType &&
              item.type === params.type &&
              item.parameter === params.parameter
            ) {
              item.type = params.type;
              item.parameter = params.parameter;
              item.value = params.value;
              item.separator = params.separator;
              item.hiddenType = params.hiddenType;
            } else if (item.type === params.type && item.parameter === params.parameter) {
              item.type = params.type;
              item.parameter = params.parameter;
              item.value = params.value;
              item.separator = params.separator;
            }

            if (params.noIconValue) {
              item.noIconValue = params.noIconValue;
            }

            return item;
          });
        }
      } else {
        let check = this.queryChangeParamsCSS.findIndex((item) => {
          return item.type === params.type && item.parameter === params.parameter;
        });

        if (check !== -1) {
          this.queryChangeParamsCSS.splice(check, 1);
        }
      }

      let options = this.optionsCopy.split(" ");

      this.$store.dispatch("changeOption", {
        option: options.join(" "),
      });

      this.$store.dispatch("changeOptionCSS", {
        optionCSS: this.queryChangeParamsCSS,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.without-bottom-b {
  border-bottom: none;
}
</style>
